module.exports = __webpack_public_path__ + "img/salon-review.199504dd.png";